module.exports = __webpack_public_path__ + "img/pauli-y-root-31.110dd043.svg";